const _temp0 = require("./pages/best_of.md");
const _temp1 = require("./pages/code_of_conduct.md");
const _temp2 = require("./pages/mission.md");
const _temp3 = require("./pages/report.md");
module.exports = {
  "best_of": _temp0,
  "code_of_conduct": _temp1,
  "mission": _temp2,
  "report": _temp3
}